<select>
  <option *ngFor="let terminal of terminals">
    {{ terminal.id}} | {{terminal.name}}
  </option>
</select>

